import { MenuItem } from './MenuItem';
import styles from './styles.module.scss';
import { SideMenu } from './types';

type Props = {
  menus: SideMenu[];
};

/**
 * サイドメニューのメニュー一覧コンポーネント
 *
 * @param param0 サイドメニューのメニュー一覧
 * @returns サイドメニューのメニュー一覧コンポーネント
 */
export const SideMenuNavigation: React.FC<Props> = ({ menus }) => (
  <nav className={styles.SideMenuNavigation}>
    <ul className={styles.SideMenuNavigation__List}>
      {menus.map(({ icon, content, link, subMenus }, index) => (
        <li key={`sidemenu-item-${index}`}>
          {subMenus ? (
            <MenuItem icon={icon} content={content} subMenus={subMenus} />
          ) : (
            <MenuItem icon={icon} content={content} link={link} />
          )}
        </li>
      ))}
    </ul>
  </nav>
);
